export const LOGOUT_PATH = "logout";
